import nodeService from '@/services/nodejs'
import cakeService from '@/services/cakephp'
import janooService from '@/services/janoo/index'
import moment from 'moment'
import state from './state'

const daysWithoutCache = process.env.VUE_APP_DAYS_WITHOUT_CACHE
const maxParallelFetchRequests = process.env.VUE_APP_MAX_PARALLEL_FETCH
let newRequestsCount = 1
let doneRequestsCount = 0
let waitingRequestsCount = 0
let storageUsedSpaceInterval = 0

/***************** AUX FUNCTIONS  *********************/
const resetTransactions = (state) => {
  state.commit('RESET_INPUT_TRANSACTIONS')
  state.commit('RESET_OUTPUT_TRANSACTIONS')
  state.commit('RESET_REQUEST_ARRAY_INPUT_STATUS')
  state.commit('RESET_REQUEST_ARRAY_OUTPUT_STATUS')
  state.commit('RESET_SUPER_ARRAY_INPUT_TRANSACTIONS')
  state.commit('RESET_SUPER_ARRAY_OUTPUT_TRANSACTIONS')
}

function fillRequestArray(startDate, endDate, dateStep) {
  if (!dateStep || dateStep < 0) {
    dateStep = 1
  }

  let start = moment(startDate)
  let end = moment(endDate)
  let currentMonth = start.format('YYYY-MM')
  let requestObj = null
  let requestArray = []

  const range = [...Array(end.diff(start, 'days') + 1).keys()]
  const days = range.map((i) => moment(startDate).add(i * dateStep, 'days'))

  days.forEach((day) => {
    const dayMonth = day.format('YYYY-MM')
    if (dayMonth !== currentMonth) {
      currentMonth = dayMonth

      requestObj = {
        start: start.format('YYYY-MM-DD'),
        end: day.subtract(1, 'day').format('YYYY-MM-DD'),
      }

      requestArray.push(requestObj)
      start = day.clone()
    }
  })

  requestArray.push({
    start: start.format('YYYY-MM-DD'),
    end: end.format('YYYY-MM-DD'),
  })

  return requestArray
}

async function concurrentPromise(state, params, responseIndex) {
  const isOutput = params.inputOutput === '0'
  const statusArray = isOutput
    ? state.state.requestArrayOutputStatus
    : state.state.requestArrayInputStatus
  const setStatusMutation = isOutput
    ? 'SET_INDEX_VALUE_REQUEST_ARRAY_OUTPUT_STATUS'
    : 'SET_INDEX_VALUE_REQUEST_ARRAY_INPUT_STATUS'
  const pushMutation = isOutput
    ? 'PUSH_TO_OUTPUT_TRANSACTIONS'
    : 'PUSH_TO_INPUT_TRANSACTIONS'

  if (statusArray[responseIndex] === 'done') {
    return
  }

  state.commit(setStatusMutation, { index: responseIndex, value: '...loading' })

  try {
    const response = await cakeService.getTransactions(
      params.inputOutput,
      params.startDate,
      params.endDate
    )

    state.commit(setStatusMutation, { index: responseIndex, value: 'done' })

    if (response.globalsearch && response.globalsearch.length > 0) {
      state.commit(pushMutation, response.globalsearch)
    }

    doneRequestsCount = statusArray.filter((resp) => resp === 'done').length
    if (doneRequestsCount === statusArray.length) {
      clearTimeout(storageUsedSpaceInterval)
      storageUsedSpaceInterval = 0
    }
  } catch (error) {
    state.commit(setStatusMutation, { index: responseIndex, value: 'done' })
    console.error('concurrentPromise error >>>>', error)
  }
}

/***************** END AUX FUNCTIONS  *********************/

const financeiroStoreCommit = (state, payload) => {
  state.commit(payload.mutation, payload.value)
}

const fetchAgents = async (state) => {
  state.commit('RESET_AGENTS')
  state.commit('SET_IS_LOADING', true)

  await cakeService
    .getAjax('agents', 'list', '', 'GET', 'jsonp')
    .then((response) => {
      const agentsList = response.list.map(
        (item) => `${item.name} (${item.cpf})`
      )
      state.commit('SET_AGENTS', agentsList)
      state.commit('SET_IS_LOADING', false)
    })
}

const fetchClients = async (state) => {
  state.commit('RESET_CLIENTS')
  state.commit('SET_IS_LOADING', true)

  await cakeService
    .getAjax('clients', 'list', '', 'GET', 'jsonp')
    .then((response) => {
      const clientsList = response.list.map(
        (item) => `${item.name} (${item.cpf})`
      )
      state.commit('SET_CLIENTS', clientsList)
      state.commit('SET_IS_LOADING', false)
    })
}

const fetchFinanceReportData = async (state, params) => {
  state.commit('SET_IS_LOADING', true)
  state.commit('RESET_FINANCE_REPORT_DATA')

  await nodeService
    .getFinanceBookingReportData(params)
    .then((res) => {
      state.commit('SET_FINANCE_REPORT_DATA', res.data)
    })
    .catch((error) => {
      console.error(error)
    })
    .finally(() => {
      state.commit('SET_IS_LOADING', false)
    })
}

const fetchTransactions = async (state, params) => {
  storageUsedSpaceInterval = 0
  state.commit('SET_IS_LOADING', true)

  //create bills requests
  let requestArray = fillRequestArray(
    params.startDate,
    params.endDate,
    params.daysInternval || 1
  )

  if (params.inputOutput == '0') {
    state.commit(
      'SET_REQUEST_ARRAY_OUTPUT_STATUS',
      new Array(requestArray.length).fill('new')
    )
  }
  if (params.inputOutput == '1') {
    state.commit(
      'SET_REQUEST_ARRAY_INPUT_STATUS',
      new Array(requestArray.length).fill('new')
    )
  }

  const maxParallel = Number(maxParallelFetchRequests) || 6

  // Processa com limite de concorrência e só resolve quando todas terminarem
  let cursor = 0
  const workers = Array.from(
    { length: Math.min(maxParallel, Math.max(requestArray.length, 1)) },
    async () => {
      while (cursor < requestArray.length) {
        const idx = cursor++
        const item = requestArray[idx]
        await concurrentPromise(
          state,
          {
            startDate: item.start,
            endDate: item.end,
            inputOutput: params.inputOutput,
          },
          idx
        )
      }
    }
  )

  if (requestArray.length > 0) {
    await Promise.all(workers)
  }
}

const fetchTransactionById = async (state, payload) => {
  state.commit('SET_IS_LOADING', true)
  const poisList = state.rootState.product.pois

  await nodeService
    .getTransactionById(payload)
    .then((res) => {
      var transaction = JSON.parse(JSON.stringify(res.data[0]))

      if (payload.type == '1') {
        if (transaction.general.open == null) {
          transaction.general.open = true
        }
        transaction.payments = transaction.payments.filter(
          (transaction) => transaction.id != payload.pid
        )

        transaction.products.map(function (value, index) {
          if (!value.item.product) {
            value.item = JSON.parse(JSON.stringify(value.item))

            // REMONTANDO item.product PARA EXIBIR NO SELECT O OBJETO COMPLETO
            value.item.product = {
              uuid: value.item.uuid,
              product_name: value.item.product_name,
              type: value.item.type,
            }

            const poiIndex = poisList.findIndex(
              (p) => p.uuid == value.item.product.uuid
            )
            if (poiIndex >= 0) {
              value.item.product.product_place_name =
                poisList[poiIndex].product_place_name
            }
          }
        })

        state.commit('SET_TRANSACTION', transaction)
      }
      if (payload.type == '0') {
        var output_transaction = { ...transaction }
        output_transaction.payment = transaction.payments[0]
        output_transaction.payment.supplier_name =
          transaction.payments[0].customer_name
        output_transaction.payment.supplier_document =
          transaction.payments[0].customer_document
        delete output_transaction.payment.customer_name
        delete output_transaction.payment.customer_document
        delete output_transaction.payments
        delete output_transaction.products
        output_transaction.payment.xfields = JSON.stringify(
          output_transaction.payment
        )

        state.commit('SET_CURRENT_OUTPUT_TRANSACTION', output_transaction)
      }
    })
    .catch((error) => {
      console.log('error >>>>', error)
    })
    .finally(() => {
      state.commit('SET_IS_LOADING', false)
    })
}

const createTransaction = async (state, transaction) => {
  state.commit('SET_IS_LOADING', true)

  var TRANSACTION_COPY = transaction
  if (TRANSACTION_COPY.type == '1') {
    TRANSACTION_COPY.products.map(function (val, index) {
      delete val.item.product
    })
  }
  if (TRANSACTION_COPY.type == '0') {
    TRANSACTION_COPY.payment.xfields = JSON.stringify(TRANSACTION_COPY.payment)
  }

  let resultData = null

  try {
    const res = await nodeService.postTransaction(TRANSACTION_COPY)
    resultData = res.data
    resultData.isNew = TRANSACTION_COPY.general.id == null

    if (TRANSACTION_COPY.type == '1') {
      state.commit('PUSH_TO_INPUT_TRANSACTIONS', resultData)

      const saved = Array.isArray(resultData) ? resultData[0] : resultData
      if (saved && saved.general && saved.general.id) {
        const current = state.state.input_transaction
        state.commit('SET_TRANSACTION', {
          ...current,
          general: {
            ...current.general,
            id: saved.general.id,
          },
          payments: saved.payments || current.payments,
        })
      }
    } else if (TRANSACTION_COPY.type == '0') {
      state.commit('PUSH_TO_OUTPUT_TRANSACTIONS', resultData)
    }
  } catch (error) {
    console.error('postCreateTransacion', error)
  } finally {
    state.commit('SET_IS_LOADING', false)
  }

  return resultData
}

const deleteTransaction = async (state, transaction) => {
  state.commit('SET_IS_LOADING', true)
  var TRANSACTION_COPY = transaction

  if (TRANSACTION_COPY.type == '1') {
    TRANSACTION_COPY.payments.map(function (val, index) {
      val.removed = true
    })
  } else {
    TRANSACTION_COPY.payment.removed = true
  }

  TRANSACTION_COPY.general.removed = true

  await nodeService
    .postTransaction(TRANSACTION_COPY)
    .then((res) => {})
    .catch((error) => {
      console.log('postDeleteTransacion', error)
    })
    .finally(() => {
      state.commit('SET_IS_LOADING', false)
    })
}

const closeTransaction = async (state, form) => {
  state.commit('SET_IS_LOADING', true)

  await nodeService
    .closeTransaction(form)
    .then((res) => {})
    .catch((error) => {})
    .finally(() => {
      state.commit('SET_IS_LOADING', false)
    })
}

const sendTransaction = async (state, form) => {
  state.commit('SET_IS_LOADING', true)

  await nodeService
    .sendTransaction(form)
    .then((res) => {})
    .catch((error) => {})
    .finally(() => {
      state.commit('SET_IS_LOADING', false)
    })
}

const setIsLoading = (state, value) => {
  state.commit('SET_IS_LOADING', value)
}

export default {
  resetTransactions,
  financeiroStoreCommit,
  fetchAgents,
  fetchClients,
  fetchTransactions,
  fetchTransactionById,
  createTransaction,
  deleteTransaction,
  closeTransaction,
  sendTransaction,
  fetchFinanceReportData,
  setIsLoading,
}
